import { render, staticRenderFns } from "./VueTournamentBracketGenerator.vue?vue&type=template&id=63268282&"
import script from "./VueTournamentBracketGenerator.vue?vue&type=script&lang=js&"
export * from "./VueTournamentBracketGenerator.vue?vue&type=script&lang=js&"
import style0 from "./VueTournamentBracketGenerator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../example/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports